module.exports = __webpack_public_path__ + "static/img/intebosend.261cfbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intebosend.png
// module id = HqG7
// module chunks = 3